<rid-syllabic-keyboard-assignments
  class="h-full"
  name="Klankbord"
  [layout]="{
    KLINKERS: 'ENABLED',
    LANGE_KLINKERS: 'ENABLED',
    KORTE_LANGE_KLINKERS: 'HIDDEN',
    SPACE: 'HIDDEN',
    DUBBELE_KLINKERS: 'ENABLED',
    DRIEDUBBELE_KLINKERS: 'ENABLED',
    VIERDUBBELE_KLINKERS: 'ENABLED',
    MEDEKLINKERS: 'ENABLED',
    EXOTEN: 'HIDDEN',
    SJWAS: 'HIDDEN',
    KLANKVOET: 'HIDDEN',
    RULE: 'HIDDEN',
  }"
  [mode]="mode()"
  [prompts]="prompts()"
  (finished)="finished.emit()"
/>
